import { render, staticRenderFns } from "./FeedbackHistory.vue?vue&type=template&id=2509d994&"
import script from "./FeedbackHistory.vue?vue&type=script&lang=js&"
export * from "./FeedbackHistory.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackHistory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports